import { Component, OnInit } from '@angular/core';
import { CloudExtractLoadService } from "../cloud-extract-load.service";
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from 'src/app/shared/components/notification/notification.service';
import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';
import { DconConfigAPI } from 'src/app/features/dfte-grid-view/config/config';
import { InfoPopupComponent } from 'src/app/shared/components/info-popup/info-popup.component';
import { MatDialog } from "@angular/material/dialog";
import { HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit {
  taskList: any[] = [];
  public batchKey: string;
  selectedInstance: any;
  myFiles: string[] = [];
  submitNewBtnDisable: boolean = true;

  constructor(private celService: CloudExtractLoadService, private router: Router, private route: ActivatedRoute,
    private notification: NotificationService, public _data: DataService, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.taskList = this.updateTaskListFromCache(this.celService.submitResponse.Batch_Key_Details);
    const unUploadedTask = this.taskList.find((e) => e['download_template'] == 'Y');
    !unUploadedTask && this.onLoadClick();
    this.batchKey = this.celService.batchKey;
    this.selectedInstance = this.celService.instanceName;
  }

  updateTaskListFromCache(list) {
    if (this.celService.fileUploadedTaskList.length > 0) {
      this.celService.fileUploadedTaskList.forEach((e) => {
        const task = list.find((val) => val.task_name === e)
        task["download_template"] = "N";
      });
    }
    return list;
  }

  editConfig() {
    this.router.navigate(["../load"], { relativeTo: this.route });
  }

  onFileInputClicked(fileInput, configItem, i) {
    fileInput.value = null;
    configItem.file_uploaded = false;
    this.myFiles[i] = "";
    const idx = this.celService.fileUploadedTaskList.indexOf(configItem.task_name);
    if (idx > -1) {
      this.celService.fileUploadedTaskList.splice(idx, 1);
    }
    this.verifyAllTaskFileUpload();
  }

  onFileSelectedForCsvExtract(event, task_name, file_name) {
    const format = ["zip", "xlsm"];
    const fileFormat = (event.target.files[0].name).split('.').pop();
    if (!format.includes(fileFormat)) {
      event.target.value = null;
      this.taskList.map(e => {
        if (e.task_name === task_name) {
          e.file_uploaded = false;
        }
        return e;
      });
      this.notification.showError("Not a valid file format, zip, xlsm file required");
    } else if (event.target.files[0].name !== file_name.split("\\\\")[1]) {
      event.target.value = null;
      this.taskList.map(e => {
        if (e.task_name === task_name) {
          e.file_uploaded = false;
        }
        return e;
      });
      this.notification.showError(`Not a valid file name. File name should be exactly as ${file_name.split("\\\\")[1]}`);
    } else {
      const idx = this.taskList.findIndex((e, i) => e.task_name === task_name);
      if (idx > -1) {
        this.taskList[idx].file_uploaded = true;
        // this.taskList[idx].file_name = event.target.files[0].name;
        this.myFiles[idx] = event.target.files[0].name;
      }
      this.uploadFileForCsvExtract(this.taskList[idx], event.target.files[0]);
    }
  }

  async uploadFileForCsvExtract(task, file) {
    this._data.apiCallInProgress = true;
    document.getElementById("overlay").style.display = "block";
    const formData = new FormData();
    formData.append("batchkey", this.celService.batchKey);
    formData.append("path", `${this._data.windowFileSharePath}${this._data.projectID}\\${DconConfigAPI.APPLICATION.toUpperCase()}\\`);
    formData.append("module", file.name);
    formData.append("cloudLoad", 'true');
    formData.append("fileData", file);
    console.log("formData", formData);

    await (await this.celService.uploadExtractFromCloudLoad(formData)).subscribe(async (message) => {
      switch (message.type) {
        case HttpEventType.Response:
          this._data.apiCallInProgress = false;
          document.getElementById("overlay").style.display = "none";
          this.celService.fileUploadedTaskList.push(task.task_name)
          this.createPopup();
          break;
      }
    }, (error) => {
      this._data.apiCallInProgress = false;
      document.getElementById("overlay").style.display = "none";
      this.notification.showError("Failed to upload cloud extract file");
    });
  }

  createPopup() {
    const dialogRef = this.dialog.open(InfoPopupComponent, {
      width: "917px",
      height: "220px",
      data: {
        type: 'Upload Status',
        mess: `<b>File uploaded successfully</b>`,
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result = 'ok') {
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
        this.verifyAllTaskFileUpload();
      }
    });
  }

  onLoadClick() {
    this.celService.tabval.next("load");
    this.router.navigate(["../load"], { relativeTo: this.route });
  }

  verifyAllTaskFileUpload() {
    if (((this.taskList.filter(e => e.download_template === 'N' || e.file_uploaded)).length) === this.taskList.length) {
      this.submitNewBtnDisable = false;
    } else {
      this.submitNewBtnDisable = true;
    }
  }
}
